import { FaqModel } from './faq.model';
import { MediaModel } from './media.model';
import { PropertyListModel } from './property-list.model';

export class FrontPageModel {
  Id?: number;
  ClientId: number = 0;
  Title?: string | null;
  MetaDescription?: string | null;
  Media?: MediaModel | null;
  MediaMobile?: MediaModel | null;
  TopText?: string | null;
  Sections?: FrontPageSectionModel[] | null;
  Faqs?: FaqModel[] | null;
}

export class FrontPageSectionModel {
  Id?: number;
  SortOrder?: number;
  Name?: string | null;
  Description?: string;
  Contents?: FrontPageSectionContentModel[] | null;
  ShowSectionsAsRow?: boolean;
  Hotels?: PropertyListModel[] | null;
}

export class FrontPageSectionContentModel {
  Id?: number;
  SortOrder?: number;
  Name: string = '';
  Url: string = '';
  Media?: MediaModel | null;
}
